import { useChangeWorkspaceMutation } from 'store/redux/apis/workspace/workspace.api';

export default function useChangeWorkspace() {
  const [changeWorkspace, { isLoading }] = useChangeWorkspaceMutation();

  return {
    changeWorkspace,
    isLoading,
  };
}
